import { useState } from 'react'
import { TypographyPanel } from './TypographyPanel'

export function TypographyButton() {
  const [showPanel, setShowPanel] = useState(false)

  return (
    <>
      <button
        className="typography-toggle"
        onClick={() => setShowPanel(true)}
        title="Reading settings"
        aria-label="Typography settings"
      >
        Aa
      </button>

      {showPanel && (
        <div
          className="typography-modal-overlay"
          onClick={() => setShowPanel(false)}
        >
          <div onClick={e => e.stopPropagation()}>
            <TypographyPanel onClose={() => setShowPanel(false)} />
          </div>
        </div>
      )}
    </>
  )
}
